module.exports = __webpack_public_path__ + "static/img/2023_9_8_3.9c2ca4e8.9c2ca4e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/2023_9_8_3.9c2ca4e8.png
// module id = FWaE
// module chunks = 0